/*
  404 Not Found page
*/

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'

function NotFound () {
  return (
    <>
      <Helmet>
        <title>Page Not Found - FullStack.cash</title>
      </Helmet>
      <Container className='py-5 text-center'>
        <Row>
          <Col>
            <h1>NOT FOUND</h1>
            <p>You just hit a route that doesn&#39;t exist... the sadness.</p>
            <Link to='/' className='btn btn-primary'>
              Go Home
            </Link>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default NotFound
